export const SAMPLE_EMAILS = {
  exposure: {
    label: "The Exposure Trap",
    text: `Hey! We love your work. We're a fast-growing startup and while we can't pay much right now, this project will get MASSIVE exposure — our audience is 500k+ and we'll credit you everywhere. Think of it as portfolio-building. If it goes well, tons of paid work will follow. Can you turn it around by next Friday?`,
  },
  scope: {
    label: "The Scope Creep Rush",
    text: `Quick one — I know we agreed on the landing page, but could you just quickly add a blog section, a login flow, and maybe hook it up to Stripe while you're at it? Should be minor for someone of your skill. Also we need it by Monday because our investor demo moved up. Same budget works, right?`,
  },
  revisions: {
    label: "The Unlimited Revisions Nightmare",
    text: `We'd like to move forward but our team needs to be 100% happy with the final design. So we'll need unlimited revisions until everyone signs off — CEO, marketing, product, and legal all need to weigh in. Payment on final approval only. Should be quick since you're the expert!`,
  },
  delayed: {
    label: "The Net-90 Payment Ambush",
    text: `Great, let's proceed. Our standard vendor terms are net-90 after invoice, and we pay after the product officially launches (target Q3). We'll also need you to sign our NDA and IP assignment before starting. Please send over your best rate — we're comparing 5 freelancers.`,
  },
};
